var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconObjective48Line = function SvgIconObjective48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.97 17.046a6.7 6.7 0 1 0 0 13.4 6.7 6.7 0 0 0 0-13.4Zm0 10a3.3 3.3 0 1 1 0-6.6 3.3 3.3 0 0 1 0 6.6Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m39.17 36.536-3.69-3.68a14.7 14.7 0 1 0-23 0l-3.68 3.68 2.4 2.41 3.69-3.69a14.6 14.6 0 0 0 18.22 0l3.69 3.69 2.37-2.41Zm-15.2-1.49a11.3 11.3 0 1 1 11.3-11.3 11.31 11.31 0 0 1-11.3 11.3Z",
    fill: "current"
  })));
};
export default SvgIconObjective48Line;